import { format, subMonths } from "date-fns"

export const INQUIRED_STATUS_REASON_OPTIONS = [
    'Ghosted',
    'Too young',
    'Went with another school',
    'Pricing',
    'Decided to wait',
    'Instrument not available',
    'Wants In-Studio',
    'Only Wants Intro'
]

export const calculateAverageLessonsPerMonth = (teacherId, timesheets) => {
    const teacherTimesheets = timesheets.filter(timesheet => timesheet.teacherId === teacherId)
    let eachMonthsAverage = {}
    let totalAverageArray = []
    teacherTimesheets.map(timesheet => {
        eachMonthsAverage[timesheet.monthYear] = { lessonCount: 0, students: 0}
        timesheet.families.map(family => {
            let myMap = {}
            family.lessons.map(lesson => {
                if(myMap[lesson.studentName]) {
                    eachMonthsAverage[timesheet.monthYear].lessonCount++
                } else {
                    myMap[lesson.studentName] = true
                    eachMonthsAverage[timesheet.monthYear].students++
                    eachMonthsAverage[timesheet.monthYear].lessonCount++
                }
            })
        })
        totalAverageArray.push(eachMonthsAverage[timesheet.monthYear].lessonCount / eachMonthsAverage[timesheet.monthYear].students)
    })
    return Math.round(averageWithoutMin(totalAverageArray) * 10) / 10
}

function averageWithoutMin(numbers) {
    // Find the minimum value in the array
    const min = Math.min(...numbers);
    // Find the index of the first occurrence of the minimum value
    const index = numbers.indexOf(min);  
    // Remove the minimum value at that index
    const filtered = numbers.length > 1 ? [...numbers.slice(0, index), ...numbers.slice(index + 1)] : numbers;
    // Calculate the average of the remaining numbers
    const sum = filtered.reduce((acc, number) => acc + number, 0);
    const average = sum / filtered.length;
    return average;
}
  
export const calculateTeachersChurn = (teacherId, timesheets) => {
    let teachersTimesheets = timesheets.filter(timesheet => timesheet.teacherId === teacherId)
    teachersTimesheets = sortTimesheetsByMonthYear(teachersTimesheets)
    let arrayOfEachMonthsChurn = []
    let totalStudentsObj = {}
    for(let i = 0; i < teachersTimesheets.length; i++) {
        for(let k = 0; k < teachersTimesheets[i].families.length; k++) {
            for(let j = 0; j < teachersTimesheets[i].families[k].lessons.length; j++) {
                totalStudentsObj[teachersTimesheets[i].families[k].lessons[j].studentName + teachersTimesheets[i].families[k].familyName] = true
            }
        }
    }

    if(teachersTimesheets.length > 0) {
        let mostRecentTimesheets = getMostRecentTimesheets(teachersTimesheets)
        let mostRecentStudentsObj = {}
        for(let l = 0; l < mostRecentTimesheets.length; l++) {
            for(let i = 0; i < mostRecentTimesheets[l].families.length; i++) {
                for(let k = 0; k < mostRecentTimesheets[l].families[i].lessons.length; k++) {
                    mostRecentStudentsObj[mostRecentTimesheets[l].families[i].lessons[k].studentName + mostRecentTimesheets[l].families[i].familyName] = true
                }
            }
        }
        let studentsWhoLeft = (Object.keys(totalStudentsObj).length - Object.keys(mostRecentStudentsObj).length)
        let churn = (studentsWhoLeft / Object.keys(totalStudentsObj).length) * 100
        let teacherRating = generateTeacherRating(Object.keys(totalStudentsObj).length, churn, calculateAverageLessonsPerMonth(teacherId, timesheets))
        return Math.round(churn)
    } else {
        return null
    }
}

export const calculateTeacherRating = (teacherId, timesheets) => {
    let teachersTimesheets = timesheets.filter(timesheet => timesheet.teacherId === teacherId)
    teachersTimesheets = sortTimesheetsByMonthYear(teachersTimesheets)
    let arrayOfEachMonthsChurn = []
    let totalStudentsObj = {}
    for(let i = 0; i < teachersTimesheets.length; i++) {
        for(let k = 0; k < teachersTimesheets[i].families.length; k++) {
            for(let j = 0; j < teachersTimesheets[i].families[k].lessons.length; j++) {
                totalStudentsObj[teachersTimesheets[i].families[k].lessons[j].studentName + teachersTimesheets[i].families[k].familyName] = true
            }
        }
    }

    if(teachersTimesheets.length > 0) {
        let mostRecentTimesheets = getMostRecentTimesheets(teachersTimesheets)
        let mostRecentStudentsObj = {}
        for(let l = 0; l < mostRecentTimesheets.length; l++) {
            for(let i = 0; i < mostRecentTimesheets[l].families.length; i++) {
                for(let k = 0; k < mostRecentTimesheets[l].families[i].lessons.length; k++) {
                    mostRecentStudentsObj[mostRecentTimesheets[l].families[i].lessons[k].studentName + mostRecentTimesheets[l].families[i].familyName] = true
                }
            }
        }
        let studentsWhoLeft = (Object.keys(totalStudentsObj).length - Object.keys(mostRecentStudentsObj).length)
        let churn = (studentsWhoLeft / Object.keys(totalStudentsObj).length) * 100
        let teacherRating = generateTeacherRating(Object.keys(totalStudentsObj).length, churn, calculateAverageLessonsPerMonth(teacherId, timesheets))
        return (Math.round(teacherRating * 100) / 100) * 100
    } else {
        return null
    }
}

const generateTeacherRating = (totalStudents, churn, lpt) => {
    return (totalStudents * lpt) / (totalStudents + (churn * 16)) //16 is the average lifetime value of a student
}

const getMostRecentTimesheets = (timesheets) => {
    let lastMonthNumber = format(subMonths(new Date(), 1), 'M')
    let thisYear = format(new Date(), 'yyyy')
    let allTimesheets = []
    for(let i = 0; i < timesheets.length; i++) {
        if(timesheets[i].monthNumber === parseInt(lastMonthNumber) && timesheets[i].year === parseInt(thisYear)) {
            allTimesheets.push(timesheets[i])
        }
    }
    return allTimesheets
}

function sortTimesheetsByMonthYear(timesheets) {
    timesheets.sort(function(a, b) {
      let dateA = new Date(a.monthYear);
      let dateB = new Date(b.monthYear);
      return dateA - dateB;
    });
    return timesheets;
  }
  
export const tallyTotalLessons = (teacherId, timesheets) => {
    let teachersTimesheets = timesheets.filter(timesheet => timesheet.teacherId === teacherId)
    let totalLessons = 0
    for(let i = 0; i < teachersTimesheets.length; i++) {
        for(let k = 0; k < teachersTimesheets[i].families.length; k++) {
            totalLessons += teachersTimesheets[i].families[k].lessons.length
        }
    }
    return totalLessons
}
export const createEllipses = (string, num) => {
    if(string.length > num) {
        return string.slice(0, num) + '...'
    } else {
        return string
    }
}

export const convertSchoolNamesToAbbreviations = (school) => {
    switch(school) {
        default: return ''
        case 'Mountainside Music Academy': return 'mma'
        case 'Lakeside Music Academy': return 'lsma'
        case 'Treeside Music Academy': return 'tma'
        case 'Morningside Music Academy': return 'mor'
        case 'Parkside Music Academy': return 'psma'
        case 'Denton Music Academy': return 'den'
        case 'Tempe Music Academy': return 'tem'
        case 'Tulsa Music Academy': return 'tul'
    }
}

export const convertSchoolAbbreviationsToNames = (school) => {
    switch(school) {
        default: return ''
        case 'mma': return 'Mountainside Music Academy'
        case 'lsma': return 'Lakeside Music Academy'
        case 'tma': return 'Treeside Music Academy'
        case 'mor': return 'Morningside Music Academy'
        case 'psma': return 'Parkside Music Academy'
        case 'den': return 'Denton Music Academy'
        case 'tem': return 'Tempe Music Academy'
        case 'tul': return 'Tulsa Music Academy'
    }
}

export const createSchoolLogoLinkFromAbbreviation = (school) => {
    if(school.toLowerCase() === 'mma') {
        return 'https://www.mountainsidemusicacademy.com/logo.png'
    } else if (school.toLowerCase() === 'lsma') {
        return 'https://www.lakesidemusicacademy.com/logo.png'
    } else if (school.toLowerCase() === 'tma') {
        return 'https://www.treesidemusicacademy.com/logo.png'
    } else if (school.toLowerCase() === 'mor') {
        return 'https://www.morningsidemusicacademy.com/logo.png'
    } else if (school.toLowerCase() === 'psma') {
        return 'https://www.parksidemusicacademy.com/logo.png'
    } else if (school.toLowerCase() === 'den') {
        return 'https://www.atharomusic.com/denton-logo__dark.png'
    } else if (school.toLowerCase() === 'tem') {
        return 'https://www.atharomusic.com/tempe-logo__dark.png'
    } else if (school.toLowerCase() === 'tul') {
        return 'https://www.atharomusic.com/tulsa-logo__dark.png'
    }
}

export const displayVersionNumber = () => {
    return 'Version 3.8.1' // Replace with your actual version number
}
